<template>
    <default-view-layout title="Manage Suppliers">
        <suppliers-table
            :is-loading="isLoading"
            :suppliers-data="suppliersData"
            @change:search-suppliers="searchSuppliers"
            @click:create-supplier="openSupplierModal"
            @click:edit-supplier="
                supplierClicked => openSupplierModal(supplierClicked)
            "
        ></suppliers-table>
        <el-pagination
            :current-page.sync="currentPage"
            :total="totalSuppliers"
            :page-size.sync="limit"
            :page-sizes="[10, 25, 50]"
            class="pagination-footer"
            layout="prev, pager, next, sizes, ->, total"
            @size-change="setLimit"
            @current-change="setPage"
        ></el-pagination>
        <supplier-modal
            :visible="showSupplierModal"
            :current-supplier="currentSupplier"
            :initial-active-tab="initialActiveSupplierModalTab"
            @close="closeSupplierModal"
            @save="saveSupplier"
            @delete="deleteSupplier"
            @delete:supplier-products="deleteSupplierProducts"
        ></supplier-modal>
    </default-view-layout>
</template>

<script>
import { SupplierService } from "Services/SupplierService";
import { ProductService } from "Services/ProductService";
import ImmutableCollectionMixin from "Mixins/ImmutableCollectionMixin";

import DefaultViewLayout from "Layouts/DefaultViewLayout";

import SupplierModal from "./components/SupplierModal";
import SuppliersTable from "./components/SuppliersTable";

export default {
    components: {
        DefaultViewLayout,
        SupplierModal,
        SuppliersTable,
    },
    mixins: [ImmutableCollectionMixin],
    data: () => ({
        showSupplierModal: false,
        initialActiveSupplierModalTab: "supplier_details",
        suppliersData: [],
        currentSupplier: {},
        isLoading: false,
        search: "",
        searchTimer: null,
        currentPage: 1,
        limit: 10,
        totalSuppliers: 0,
    }),
    async mounted() {
        this.getSuppliers();
    },
    methods: {
        async saveSupplier(supplier) {
            this.isLoading = true;
            this.closeSupplierModal();
            // update existing supplier
            if (supplier._id) {
                const updatedSupplier = await SupplierService.updateSupplier(
                    supplier
                );
                this.suppliersData = this.$_immutableCollection_update(
                    this.suppliersData,
                    updatedSupplier
                );
            }
            // create new supplier
            else {
                const newSupplier = await SupplierService.createSupplier(
                    supplier
                );
                this.suppliersData = this.$_immutableCollection_insert(
                    this.suppliersData,
                    newSupplier
                );
            }
            this.isLoading = false;
        },

        async deleteSupplier(supplierIdToDelete) {
            this.isLoading = true;
            await SupplierService.deleteSupplier(supplierIdToDelete);
            this.suppliersData = this.$_immutableCollection_deleteById(
                this.suppliersData,
                supplierIdToDelete
            );
            this.closeSupplierModal();

            this.isLoading = false;
            this.$message({
                type: "success",
                message: "Deleted Supplier",
            });
        },

        async deleteSupplierProducts(supplierId) {
            this.isLoading = true;
            await ProductService.deleteAll(supplierId);

            this.closeSupplierModal();
            this.isLoading = false;

            this.$message({
                type: "success",
                message: "Deleted Suppliers Products",
            });
        },

        async getSuppliers() {
            this.isLoading = true;
            if (this.search.length < 3) {
                const getSuppliersResponse = await SupplierService.getAllPaginated(
                    this.limit,
                    this.currentPage - 1
                );
                this.suppliersData = getSuppliersResponse.data;
                this.totalSuppliers = getSuppliersResponse.total;
            } else {
                const searchSuppliersResponse = await SupplierService.searchAll(
                    this.search,
                    this.limit,
                    this.currentPage - 1
                );
                this.suppliersData = searchSuppliersResponse.data;
                this.totalSuppliers = searchSuppliersResponse.total;
            }
            this.isLoading = false;
        },

        openSupplierModal(supplier = {}) {
            this.currentSupplier = supplier;
            this.initialActiveSupplierModalTab = "supplier_details";
            this.showSupplierModal = true;
        },
        closeSupplierModal() {
            this.showSupplierModal = false;
            this.getSuppliers();
        },

        searchSuppliers(search) {
            this.currentPage = 1;
            this.search = search;
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.getSuppliers();
            }, 500);
        },

        setLimit(limit) {
            this.limit = limit;
            this.getSuppliers();
        },
        setPage(page) {
            this.currentPage = page;
            this.getSuppliers();
        }
    },
};
</script>

<style scoped lang="scss">
.create-supplier {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
}
</style>
